import { useMutation } from "react-query";

import { httpService } from "utils";

import { useGetAuthorizationStore } from "../../authentication/infrastructure/useGetAuthorizationStore";
import { DateObject } from "../../../utils/DateObject";
import { IAppointmentActionResponseDto } from "../../appointment/Dtos/IAppointmentActionResponseDto";
import { IAppointmentActionResponse } from "../../appointment/types/IAppointmentActionResponse";

export const useEditUserAppointment = (
  intervalId: number,
  appointmentId: string
) => {
  const { userId } = useGetAuthorizationStore((state) => ({
    userId: state.userId,
  }));

  if (!userId) {
    throw new Error("UserId not found");
  }

  return useMutation((data: FormData) => {
    return editUserAppointment(data, userId, appointmentId, intervalId);
  });
};

const editUserAppointment = (
  formData: FormData,
  userId: string,
  appointmentId: string,
  intervalId: number
): Promise<IAppointmentActionResponse> => {
  return httpService()
    .post<IAppointmentActionResponseDto>(
      `/e-reservation/user/${userId}/appointment/${appointmentId}/edit/${intervalId}`,
      formData
    )
    .then((res) => {
      return {
        ...res,
        createDate: DateObject(res.createDate),
        startDate: DateObject(res.startDate),
        endDate: DateObject(res.endDate),
      };
    });
};
